export const MNEMONIC_DEFAULT_SHADOW = {
    color: 'rgba(0, 0, 0, 0.35)',
    blur: 10,
    offsetX: 4,
    offsetY: 4,
    affectStroke: false,
    nonScaling: false,
} as const;

export function isMnemonicShadowEnabled(shadow: unknown): boolean {
    return shadow != null && typeof shadow === 'object';
}

export function createMnemonicShadow(): typeof MNEMONIC_DEFAULT_SHADOW {
    return { ...MNEMONIC_DEFAULT_SHADOW };
}

/** Сбрасывает тень на 2D-контексте перед отрисовкой вложенного содержимого (ECharts и т.п.). */
export function clearMnemonicCanvasShadow(ctx: CanvasRenderingContext2D): void {
    ctx.shadowColor = 'transparent';
    ctx.shadowBlur = 0;
    ctx.shadowOffsetX = 0;
    ctx.shadowOffsetY = 0;
}

export function resolveMnemonicShadowFromJson(shadow: unknown): typeof MNEMONIC_DEFAULT_SHADOW | null {
    if (!isMnemonicShadowEnabled(shadow)) {
        return null;
    }

    return {
        ...MNEMONIC_DEFAULT_SHADOW,
        ...(shadow as Record<string, unknown>),
    };
}
